// Create types
export const CUSTOMER_CREATE_ERROR = 'CUSTOMER_CREATE_ERROR';
export const CUSTOMER_CREATE_LOADING = 'CUSTOMER_CREATE_LOADING';
export const CUSTOMER_CREATE_SUCCESS = 'CUSTOMER_CREATE_SUCCESS';
export const CUSTOMER_CREATE_VIOLATIONS = 'CUSTOMER_CREATE_VIOLATIONS';
export const CUSTOMER_CREATE_RESET = 'CUSTOMER_CREATE_RESET';

// Show types
export const CUSTOMER_SHOW_ERROR = 'CUSTOMER_SHOW_ERROR';
export const CUSTOMER_SHOW_LOADING = 'CUSTOMER_SHOW_LOADING';
export const CUSTOMER_SHOW_RETRIEVED_SUCCESS = 'CUSTOMER_SHOW_RETRIEVED_SUCCESS';
export const CUSTOMER_SHOW_RESET = 'CUSTOMER_SHOW_RESET';

// Update types
export const CUSTOMER_UPDATE_RESET = 'CUSTOMER_UPDATE_RESET';
export const CUSTOMER_UPDATE_UPDATE_ERROR = 'CUSTOMER_UPDATE_UPDATE_ERROR';
export const CUSTOMER_UPDATE_UPDATE_LOADING = 'CUSTOMER_UPDATE_UPDATE_LOADING';
export const CUSTOMER_UPDATE_UPDATE_SUCCESS = 'CUSTOMER_UPDATE_UPDATE_SUCCESS';
export const CUSTOMER_UPDATE_RETRIEVE_ERROR = 'CUSTOMER_UPDATE_RETRIEVE_ERROR';
export const CUSTOMER_UPDATE_RETRIEVE_LOADING = 'CUSTOMER_UPDATE_RETRIEVE_LOADING';
export const CUSTOMER_UPDATE_RETRIEVE_SUCCESS = 'CUSTOMER_UPDATE_RETRIEVE_SUCCESS';
export const CUSTOMER_UPDATE_UPDATE_VIOLATIONS = 'CUSTOMER_UPDATE_UPDATE_VIOLATIONS';

// Delete types
export const CUSTOMER_DELETE_ERROR = 'CUSTOMER_DELETE_ERROR';
export const CUSTOMER_DELETE_LOADING = 'CUSTOMER_DELETE_LOADING';
export const CUSTOMER_DELETE_SUCCESS = 'CUSTOMER_DELETE_SUCCESS';
export const CUSTOMER_DELETE_RESET = 'CUSTOMER_DELETE_RESET';

// List types
export const CUSTOMER_LIST_ERROR = 'CUSTOMER_LIST_ERROR';
export const CUSTOMER_LIST_LOADING = 'CUSTOMER_LIST_LOADING';
export const CUSTOMER_LIST_RESET = 'CUSTOMER_LIST_RESET';
export const CUSTOMER_LIST_PAGINATION = 'CUSTOMER_LIST_PAGINATION';
export const CUSTOMER_LIST_SUCCESS = 'CUSTOMER_LIST_SUCCESS';
export const CUSTOMER_LIST_ORDER = 'CUSTOMER_LIST_ORDER';
export const CUSTOMER_LIST_PAGE = 'CUSTOMER_LIST_PAGE';

// List agreements

export const CUSTOMER_AGREEMENT_LIST_ERROR = 'CUSTOMER_AGREEMENT_LIST_ERROR';
export const CUSTOMER_AGREEMENT_LIST_LOADING = 'CUSTOMER_AGREEMENT_LIST_LOADING';
export const CUSTOMER_AGREEMENT_LIST_SUCCESS = 'CUSTOMER_AGREEMENT_LIST_SUCCESS';
export const CUSTOMER_AGREEMENT_LIST_ORDER = 'CUSTOMER_AGREEMENT_LIST_ORDER';

// List documents

export const CUSTOMER_DOCUMENT_LIST_ERROR = 'CUSTOMER_DOCUMENT_LIST_ERROR';
export const CUSTOMER_DOCUMENT_LIST_LOADING = 'CUSTOMER_DOCUMENT_LIST_LOADING';
export const CUSTOMER_DOCUMENT_LIST_SUCCESS = 'CUSTOMER_DOCUMENT_LIST_SUCCESS';
export const CUSTOMER_DOCUMENT_LIST_ORDER = 'CUSTOMER_DOCUMENT_LIST_ORDER';


// WEBPACK FOOTER //
// ./src/store/modules/customer/mutation-types.js